var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isProvisioning)?_c('p',[_vm._v(_vm._s(_vm.$t("dg_suite.consent_management.still_provisioning")))]):(_vm.wasProvisioned)?_c('p',{staticClass:"consent-management__provision-success"},[_vm._v(" "+_vm._s(_vm.$t("dg_suite.consent_management.successfully_provisioned"))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }